"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boxShadow = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var color_1 = require("./color");
var measure_unit_1 = require("./measure-unit");
exports.boxShadow = type_guard_1.union([
    type_guard_1.string(),
    type_guard_1.props({
        inset: type_guard_1.optional(type_guard_1.boolean()),
        x: measure_unit_1.measureUnit,
        y: measure_unit_1.measureUnit,
        blur: measure_unit_1.measureUnit,
        spread: measure_unit_1.measureUnit,
        color: color_1.color.any
    })
]);
